import React from "react";

export default function MetricCard({
  label,
  value,
  suffix,
  trend,
  helper,
  testId,
}) {
  const delta = typeof trend === "number" ? trend : null;
  const trendClass =
    delta === null
      ? "text-zinc-500"
      : delta > 0
      ? "text-emerald-600"
      : delta < 0
      ? "text-rose-600"
      : "text-zinc-500";
  return (
    <div className="card-flat p-5 h-full" data-testid={testId}>
      <div className="label-eyebrow">{label}</div>
      <div className="mt-3 flex items-baseline gap-2">
        <div className="display text-4xl font-black tracking-tight tabular-nums">
          {value}
        </div>
        {suffix && <div className="text-sm text-zinc-500">{suffix}</div>}
      </div>
      {(helper || delta !== null) && (
        <div className="mt-3 flex items-center gap-2 text-xs">
          {delta !== null && (
            <span className={`mono ${trendClass}`} data-testid={`${testId}-delta`}>
              {delta > 0 ? "▲" : delta < 0 ? "▼" : "·"} {Math.abs(delta).toFixed(1)}
            </span>
          )}
          {helper && <span className="text-zinc-500">{helper}</span>}
        </div>
      )}
    </div>
  );
}
